import React from "react";
import { Link } from "react-router-dom";
import { Crown, Sparkles } from "lucide-react";

export const StudioProBanner = ({ studioPro }) => (
  <section
    className="mb-6 rounded-2xl border border-amber-300/30 bg-gradient-to-br from-fuchsia-950/60 to-[#120a18] p-4 sm:p-5"
    data-testid="studio-pro-banner"
  >
    <p className="inline-flex items-center gap-1.5 text-[10px] tracking-widest uppercase font-black text-amber-300" data-testid="studio-pro-banner-badge">
      <Crown className="w-3.5 h-3.5" /> RGM Studio Pro Now Available
    </p>
    <h2 className="mt-1 text-lg font-black tracking-tight" data-testid="studio-pro-banner-title">RGM Studio Pro is here!</h2>
    <p className="mt-1 text-sm text-gray-300">
      Take your sound to the next level with professional vocal effects, mixing tools, reverb, delay, and more!
    </p>
    {studioPro === null ? null : studioPro ? (
      <p className="mt-3 text-sm text-amber-100 inline-flex items-center gap-1.5" data-testid="studio-pro-banner-included">
        <Sparkles className="w-4 h-4 text-amber-300" /> RGM Studio Pro is included in your membership!
      </p>
    ) : (
      <div className="mt-3 flex flex-wrap items-center gap-3" data-testid="studio-pro-banner-free">
        <p className="text-sm text-gray-300">Keep creating with RGM Studio Basic. Upgrade to unlock Pro effects.</p>
        <Link to="/membership" className="h-9 px-4 rounded-full bg-amber-400 text-black text-sm font-black inline-flex items-center active:scale-95 transition-transform" data-testid="studio-pro-banner-upgrade">
          Upgrade
        </Link>
      </div>
    )}
    <p className="mt-3 text-[11px] text-gray-400">Premium Monthly, Premium Yearly &amp; Lifetime Founding Artists: Pro is included.</p>
    <p className="mt-2 text-xs font-black tracking-widest text-fuchsia-300">YOUR ONLY LIMIT IS YOU!</p>
  </section>
);
